const Group = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6041 11.048C17.2131 10.0101 17.4761 8.80531 17.3551 7.608C17.1761 5.824 16.1801 4.247 14.5521 3.168L13.4471 4.834C14.5661 5.576 15.2471 6.633 15.3651 7.808C15.4195 8.3541 15.3515 8.90546 15.1661 9.42198C14.9806 9.9385 14.6824 10.4072 14.2931 10.794L13.1011 11.986L14.7191 12.461C18.9511 13.701 19.0001 17.957 19.0001 18H21.0001C21.0001 16.211 20.0441 12.715 16.6041 11.048Z"
        fill={color}
      />
      <path
        d="M9.5 12C11.706 12 13.5 10.206 13.5 8C13.5 5.794 11.706 4 9.5 4C7.294 4 5.5 5.794 5.5 8C5.5 10.206 7.294 12 9.5 12ZM9.5 6C10.603 6 11.5 6.897 11.5 8C11.5 9.103 10.603 10 9.5 10C8.397 10 7.5 9.103 7.5 8C7.5 6.897 8.397 6 9.5 6ZM11 13H8C4.691 13 2 15.691 2 19V20H4V19C4 16.794 5.794 15 8 15H11C13.206 15 15 16.794 15 19V20H17V19C17 15.691 14.309 13 11 13Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Group;
